import { ChatBotRecordRole } from "@/API";

export function ChatBotRecordRoleToNumber(role?: ChatBotRecordRole) {
    if (role == "System") return 1
    if (role == "User") return 2
    if (role == "Tool") return 3
    if (role == "Assistant") return 4
    return 5
}